<template>

<div :class="'nbar-w '+actualClass">
<CNavbar expand="lg" color-scheme="light" class="bg-light nbar-custom">
  <CContainer fluid>
    <CNavbarBrand @Click='clickRedirect("/#uvod")' class="navpointer">
      <img src="../../src/assets/photos/AK_logo_no_text.svg" id="brand-img" height="85"/>
    </CNavbarBrand>
    <CNavbarToggler @click="toggler_visible = !toggler_visible"/>
    <CCollapse class="navbar-collapse" :visible="toggler_visible">
      <CNavbarNav>

        <CNavItem class="navpointer">
          <CNavLink @Click='clickRedirect("/#historie")'>Historie</CNavLink>
        </CNavItem>
        

        <CDropdown variant="nav-item" :popper="false">
          <CDropdownToggle>Pro veřejnost</CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem @Click='clickRedirect("/zazitkovelety")'>Zážitkové lety</CDropdownItem>
            <CDropdownItem @Click='clickRedirect("/zazitkovelety#pilotemnazkousku")' >Pilotem na zkoušku</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>


        <CDropdown variant="nav-item" :popper="false">
          <CDropdownToggle>Pilotní výcvik</CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem @Click='clickRedirect("/clenstvi")'>Členství</CDropdownItem>
            <CDropdownItem @Click='clickRedirect("/spl")'>Výcvik - SPL</CDropdownItem>
            <CDropdownItem @Click='clickRedirect("/ull")'>Výcvik - ULL</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>

        <CDropdown variant="nav-item" :popper="false">
          <CDropdownToggle>Pro piloty</CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem @Click='clickRedirect("/#propiloty")'>Přehled</CDropdownItem>
            <!-- <CDropdownItem @Click='clickRedirect("/#vystrahy")'>Výstrahy</CDropdownItem> -->
            <CDropdownItem href="https://www.weatherlink.com/embeddablePage/show/7a995c6c79e74399882f588ab9fa08e2/summary" target=”_blank”>Meteostanice</CDropdownItem>
            <CDropdownItem href="https://www.youtube.com/channel/UC8R5ZVLK-NjlaxQluDZuwYQ/live" target=”_blank”>Webkamera</CDropdownItem>
            <CDropdownItem href="https://aim.rlp.cz/vfrmanual/actual/lkkm_text_cz.html" target=”_blank”>AIP ČR</CDropdownItem>
            <CDropdownItem @Click='clickRedirect("/#kontaktni-formular")'>Oznámení příletu</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>

        <CDropdown variant="nav-item" :popper="false">
          <CDropdownToggle>Dokumenty</CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem href="/documents/Bezpecnostni_program_web.pdf" target=”_blank”>Bezpečnostní program</CDropdownItem>
            <CDropdownItem href="/documents/Havarijni_plan_AKKM_web.pdf" target=”_blank”>Havarijní plán</CDropdownItem>
            <CDropdownItem href="/documents/Letistni_rad_web.pdf" target=”_blank”>Letištní řád</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>

        <!-- style="margin-left: auto;" -->
        <CDropdown variant="nav-item" :popper="false" > 
          <CDropdownToggle>Přihlášení</CDropdownToggle>
          <CDropdownMenu>
            <CDropdownItem href="https://forum.lkkm.cz" target=”_blank”>Fórum</CDropdownItem>
            <CDropdownItem href="https://akkm.flightoffice.cz" target="_blank">Flight Office</CDropdownItem>
          </CDropdownMenu>
        </CDropdown>

        <CNavItem class="navpointer">
          <CNavLink @Click='clickRedirect("/kontakty")'>Kontakty</CNavLink>
        </CNavItem>

      </CNavbarNav>


    </CCollapse>
  </CContainer>
</CNavbar>
</div>

</template>

<script>
import { onMounted, ref } from '@vue/runtime-core';
import { useRouter } from 'vue-router';
import { CNavbar,CNavbarNav,CContainer,CNavbarBrand,CNavbarToggler,CCollapse,CNavItem,CNavLink,CDropdown,CDropdownMenu,CDropdownToggle,CDropdownItem } from '@coreui/vue';


export default {
  components: {CNavbar,CNavbarNav,CContainer,CNavbarBrand,CNavbarToggler,CCollapse,CNavItem,CNavLink,CDropdown,CDropdownMenu,CDropdownToggle,CDropdownItem},
  setup(){
    var scrollPosition = null;
    const actualClass = ref("nbar-ontop")
    const DEBOUNCE_TIMEOUT = 50;
    const toggler_visible = ref(false);

    const router = useRouter();
    const clickRedirect = function(url){
      router.push(url)
    }

    const throttle = function (callback, limit) {
        var waiting = false;
        return function () {
            if (!waiting) {
                callback();
                waiting = true;
                setTimeout(function () {
                    waiting = false;
                }, limit);
            }
        }
    }

    const setClass = function(){
      scrollPosition = window.scrollY
      if (scrollPosition > 400){
        actualClass.value = "nbar-notontop"
        document.getElementById("brand-img").height = 50;
      }
      else{
        actualClass.value = "nbar-ontop"
        document.getElementById("brand-img").height = 85;
      }
    }


    onMounted(()=>{
      window.addEventListener('scroll', throttle(setClass, DEBOUNCE_TIMEOUT));
    })

    return {actualClass, toggler_visible, clickRedirect}
  }
}

</script>

<style scoped>

.nbar-notontop{
  transition: 0.4s;
  background: rgba(255, 255, 255, 1);
  color: white !important;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}

.nbar-ontop{
 background: rgba(0,0,0,0) !important;
 transition: 0.4s;
}

.nbar-custom{
  background: rgba(0,0,0,0) !important;
  padding: 0 !important;
}
.nbar-w{
  position: absolute;
  margin: 0 !important;
  border: 0 !important;

  top: 0px;
  z-index: 100;
  width: 100%;
}

.navpointer{
  cursor: pointer;
}

.dropdown-menu.show{
  background-color: transparent !important;
  border: 0 !important;
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
}

.collapse.show.navbar-collapse{
  -webkit-backdrop-filter: blur(50px);
  backdrop-filter: blur(50px);
}

</style>